import React from 'react'; 
import MoveModal from './modals/MoveModal';
import ImageModal from './modals/ImageModal';
import DeleteModal from './modals/DeleteModal';

const ActionModals = ({ activeModal, closeModal, handleDeleteSelected, handleImageSelected, handleMoveSelected }) => {
  return (
    <>
      <MoveModal
        open={activeModal === 'move'}
        closeModal={closeModal}
        handleMoveSelected={handleMoveSelected}
      />

      <ImageModal
        open={activeModal === 'image'}
        closeModal={closeModal}
        handleImageSelected={handleImageSelected}
      />

      <DeleteModal
        open={activeModal === 'delete'}
        closeModal={closeModal}
        handleDeleteSelected={handleDeleteSelected}
      />
    </>
  );
};

export default ActionModals;
